module.exports = __webpack_public_path__ + "img/view3.3ec8a3b3.jpg";